export class PagerDetails {
    id: number;
    serialNbr: string;
    nbr: string;
    hint: string;
    available: boolean;
}
